import React, { Fragment } from 'react';
import IconTooltip from '../iconTooltip/iconTooltip';
import styles from './styles.css';

const AgendaListTitle = ({ resource }) => {
  const surroundInCheck = text => (
    <Fragment>
      <IconTooltip text="Transfer completed" icon="check-circle" className={`stroke-dark mr2 ${styles.icon}`} />
      {text}
    </Fragment>
  );
  if (resource.type === 'LOT_TRANSFER') {
    const transferTitle = `${resource.lot.reference}: ${resource.lotTransfer.name}`;
    return resource.lotTransfer.status === 'COMPLETED' ? surroundInCheck(transferTitle) : transferTitle;
  }

  const transferTitle = `${resource.lot.reference}: Start brew`;
  return resource.status !== 'PENDING' ? surroundInCheck(transferTitle) : transferTitle;
};

export default AgendaListTitle;



// WEBPACK FOOTER //
// ./src/components/agendaListTitle/agendaListTitle.jsx